import React, { useEffect, useState } from 'react'
import { LuMoon } from "react-icons/lu";
import { LuSunMoon } from "react-icons/lu";
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { setIsTheme } from '../store/slice/currentStageSlice';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import { persistor, store } from '../store/store';
import { resetPermissions } from '../store/slice/permissionSlice';
import BhashiniTranslator from './BhashiniTranslator';

export default function DashboardHeader() {
  const [showNavbar, setShowNavbar] = useState(false);
  const [darkMode, setDarkMode] = useState('light')
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const [show, setShow] = useState(false);
  const authData = useSelector(state => state.authToken.authData);
  const { isTheme } = useSelector((state) => state.currentStage)
  const [isUserName, setIsUserName] = useState("");
  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const isGraphDashboard = location.pathname === '/misdashboard';


  useEffect(() => {
    if (authData?.UserType === "User" || authData?.UserType === "districtuser") {
      setIsUserName(authData?.UlbName)
    } else {
      setIsUserName("Admin")
    }
  }, [])


  // const handleLogOut = () => {
  //   const tokenValue = localStorage.removeItem("token");
  //   if (!tokenValue) {
  //     navigate("/dashboard");
  //     window.location.reload();
  //   }
  // }

  const handleLogOut = async () => {

    localStorage.clear();
    await persistor.purge();
    store.dispatch({ type: 'RESET_ALL_STATE' });

    navigate("/login");
  };

  const handleThemMode = () => {
    setDarkMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };
  const handleThemMode2 = () => {
    setDarkMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", darkMode);
    dispatch(setIsTheme(darkMode));
  }, [darkMode, dispatch]);


  const navigationItems = [
    // { icon: HomeIcon, text: 'Home', },
    { icon: isTheme === 'light' ? "img/Rectangleiconloc.png" : "img/gisactive.svg", text: 'GIS Dashboard', href: '/dashboard', active: isTheme === 'light' ? "img/gisactive.svg" : "img/Rectangleiconloc.png" },
    { icon: isTheme === 'light' ? "img/misactive.svg" : "img/misicon.png", text: 'MIS Dashboard', href: '/misdashboard', active: isTheme === 'light' ? "img/misicon.png" : "img/misactive.svg" },
    {
      icon: isTheme === 'light' ? "img/activityactive.svg" : "img/activity.png",
      text: 'Activities',
      href: '/activities',
      active: isTheme === 'light' ? "img/activity.png" : "img/activityactive.svg"
    },
    {
      icon: isTheme === 'light' ? "img/dataactive.svg" : "img/datamange.png",
      text: 'Data Management',
      href: '/datamanagement',
      active: isTheme === 'light' ? "img/datamange.png" : "img/dataactive.svg"
    },
    {
      icon: isTheme === 'light' ? "img/accesactive.svg" : "img/acces.png",
      text: 'Access & Security',
      href: '/security',
      active: isTheme === 'light' ? "img/acces.png" : "img/accesactive.svg"
    },
    {
      icon: isTheme === 'light' ? "img/active-ai.svg" : "img/aiicon.png",
      text: 'GIS AI (GARUD)',
      href: '/user-chatbot',
      active: isTheme === 'light' ? "img/aiicon.png" : "img/active-ai.svg"
    },
    {
      icon: isTheme === 'light' ? "img/settingactive.svg" : "img/setting.png",
      text: 'Settings',
      href: '/settings',
      active: isTheme === 'light' ? "img/setting.png" : "img/settingactive.svg",
    }
  ];



  return (
    <div className='dash'>
      {!isGraphDashboard ? (
        <div className='shadow-sm border-bottom'>
          <div className='fixed-top'>
            <header
              style={{
                background: "linear-gradient(96.74deg, #292548 17.75%, #03856E 100%)",
                position: "relative",
                zIndex: '9'
              }}
            >
              <div className="container-fluid px-3 py-2">
                <div className="row gx-0 align-items-center">
                  <div className="col-xl-6 col-lg-6 col-md-5">
                    <div className='d-flex align-items-center'>
                      <img src="img/mplogo.png" alt="Logo" className='header-img ' />
                      <div className='text-white'>
                        <h6 className="mb-0 fs-5">GIS Based Asset and Utility Dashboard</h6>
                        <h6 className="mb-0 mt-1" style={{ fontSize: "12px", color: "#FFFFFFBF" }}>Real-Time Infrastructure Monitoring</h6>
                      </div>
                    </div>
                  </div>

                  <div className='col-xl-6 col-lg-6 col-md-7 mainheaderright'>
                    <div className='d-flex gap-3 align-items-center'>
                      <div style={{ background: "#eaf1f5", borderRadius: "6px", padding: "4px 10px" }}>
                        <BhashiniTranslator />
                      </div>
                      <div className='d-flex gap-2  align-items-center'>
                        <img src="img/user-dashboard.svg" alt="user" /><p className='text-white fs-6'>{isUserName}</p>
                      </div>
                      {/* <Link to="/dashboard" className="text-decoration-none">
                        <div className='d-flex gap-2  align-items-center'>
                          <img src="img/navigate-dashboard.svg" alt="portal" />
                          <p className='text-white fs-6'>Go to Dashboard</p>
                        </div>
                      </Link> */}
                      <div className=''>
                        <div className='logout-container' type="button" onClick={() => handleLogOut()}
                          style={{
                            backgroundColor: darkMode === "light" ? "#BF0101" : "#BF0101",
                            color: '#FFFFFF'
                          }}
                        >
                          <img src="img/poweroff.png" alt='logout' className='m-0' />
                          <h6>Logout</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
          </div>
        </div>
      )
        :
        (
          <>
            <header className="dashboarheader navbar-dash-lg"
              style={{
                background: "linear-gradient(96.74deg, #292548 17.75%, #03856E 100%)",
                position: "relative",
                zIndex: '9'
              }}
            >
              <div className="container-fluid p-0">
                <div className="row align-items-center">
                  <div className="col-xl-5 col-lg-5 col-md-12 col-12 p-0">
                    <div className='leftview-sm'>
                      <div className='headcontainer'>
                        <div className='d-flex align-items-center headerborder'>
                          <img src="img/mplogo.png" alt="Logo" className='header-img-dash ' />
                          <div className='header-title text-white'>
                            <h6 className="mb-0">Urban Data Analytics Center - GIS based</h6>
                            <h6 className="govt-title2">Government of Madhya Pradesh</h6>
                          </div>
                        </div>

                      </div>
                      <div className=''>

                        <button className="menu-toggle-dash" type="button" onClick={() => handleShowNavbar()}>
                          {!showNavbar ?
                            <img src="img/mobiebtn.png" alt='mobile' />
                            :
                            <img src="img/closebtn.svg" alt='mobile' />
                          }
                        </button>

                      </div>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7 col-md-12 col-12 p-0  align-items-center ">
                    <div className='header-right-side rightview-sm' >
                      {/* <button className='btn-play' onClick={() => setShow(true)}>
                  <img src={playIcon} alt='video' className='' />
                  Play Video</button> */}
                      {/* <div className='togglediv togglediv2'>
                        <input type="checkbox" className="checkbox" id="checkbox" onClick={() => handleThemMode()} />
                        <label for="checkbox" className="checkbox-label"
                          style={{
                            backgroundColor: darkMode === "light" ? '#1F509A' : '#194FA1'
                          }}
                        >
                          <LuMoon className='text-white' />
                          <LuSunMoon className='text-white' />
                          <span className="ball"></span>
                        </label>
                      </div> */}

                      {/* <div className='search-container'>
                        <input
                          placeholder="Search for Tools, Menus and Help"
                          className="search-input"
                         
                        />
                        <span className='search-img'>
                          <img src="img/Vectorsearch.png" alt='search' />
                        </span>
                      </div> */}

                      <div style={{ background: "#eaf1f5", borderRadius: "6px", padding: "4px 10px" }}>
                        <BhashiniTranslator />
                      </div>
                      <div className=''>
                        <div className='logout-container' type="button" onClick={() => handleLogOut()}
                          style={{
                            backgroundColor: darkMode === "light" ? "#BF0101" : "#BF0101",
                            color: '#FFFFFF'
                          }}
                        >
                          <img src="img/poweroff.png" alt='logout' className='m-0' />
                          <h6>Logout</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <header className=" dashboarheader navbar-dash-sm">
              <div className="container-fluid p-0">
                <div className="row align-items-center">
                  {/* Left Section */}
                  <div className="">
                    <div className='leftview-sm'>
                      <div className='headcontainer'>
                        <div className='d-flex align-items-center headerborder'>
                          <img src="img/mplogo.png" alt="Logo" className='header-img-dash ' />
                          <div className='header-title'>
                            <h6 className="mb-0">Urban Data Analytics Center - GIS</h6>
                            <h6 className="mb-0">based. UADD Bhopal (M.P) </h6>
                          </div>
                        </div>
                      </div>
                      <div className=''>
                        <button className="menu-toggle-dash" type="button" onClick={() => handleShowNavbar()}>
                          {isTheme === "light" ? <img src="img/light-hembuger.svg" alt='mobile' /> :
                            <img src="img/mobiebtn.png" alt='mobile' />
                          }
                        </button>

                      </div>
                    </div>
                  </div>

                  <div>
                    <div className={`main-menu fade  ${showNavbar && "show"}`} >
                      <div className='navbar-nav'>
                        <div className='mobiletoparea'>
                          <div className='d-flex align-items-center'>
                            <img src="img/mplogo.png" alt="Logo" className='header-img-dash ' />
                            <div className='header-title'>
                              <h6 className="mb-0">Urban Data Analytics Center - GIS</h6>
                              <h6 className="mb-0">based. UADD Bhopal (M.P) </h6>
                            </div>
                          </div>
                          <button className="menu-toggle-dash" type="button" onClick={() => handleShowNavbar()}>
                            {!showNavbar ?
                              <img src="img/mobiebtn.png" alt='mobile' />
                              :
                              <img src="img/closebtn.svg" alt='mobile' />
                            }
                          </button>
                        </div>
                        {navigationItems.map((item, index) => (
                          <Link
                            key={index}
                            to={item.href}
                            className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
                            onClick={() => setShowNavbar(false)}
                          >
                            {location.pathname === item.href ? <img src={item.active} alt={item.text} /> : <img src={item.icon} alt={item.text} />}

                            <span
                              className={`ml-3 transition-opacity duration-300 link-text  mobile-text-sidebar opacity-100 inline`}
                              style={{ color: isTheme === "light" && `${location.pathname != item.href ? 'active' : ''}` && "#000" }}
                            >
                              {item.text}
                            </span>
                          </Link>
                        ))}
                        {/* <button className='btn-play w-50' onClick={() => setShow(true)}>
                    <img src="img/playicon.svg" alt='video' className='' />
                    Play Video</button> */}

                        <div className="mt-2" style={{ background: "#eaf1f5", borderRadius: "6px", padding: "4px 10px" }}>
                          <BhashiniTranslator showLanguage={false} />
                        </div>
                        {/* <div className='togglediv  mt-2'>
                          <input type="checkbox" className="checkbox" id="checkbox" onClick={() => handleThemMode2()} />
                          <label for="checkbox" className="checkbox-label"
                            style={{
                              backgroundColor: darkMode === "light" ? '#1F509A' : '#194FA1'
                            }}
                          >
                            <LuMoon className='text-white' />
                            <LuSunMoon className='text-white' />
                            <span className="ball"></span>
                          </label>
                        </div> */}
                        <div className='logout-container border-0' type="button" onClick={() => handleLogOut()}>
                          <img src="img/poweroff.png" alt='logout' className='m-0' />
                          <h6>Logout</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </header>
            <Modal
              show={show}
              fullscreen={true}
              onHide={() => setShow(false)}
              className="custom-modal"
            >
              <Modal.Header className="d-flex align-items-center p-0">
                {/* Flex container for centering */}
                <div className="w-100 d-flex justify-content-center">
                  <img src="img/logo-ai.svg" alt="Logo" /> {/* Adjust height as needed */}
                </div>
                {/* Close button aligned to the right */}
                <Button variant="link" onClick={() => setShow(false)} className="ms-auto">
                  <img src="img/Circle_btns.svg" alt="Close" />
                </Button>
              </Modal.Header>

              <Modal.Body
                className="d-flex justify-content-center align-items-center p-4"
                style={{ overflow: "hidden" }} // Ensuring fixed height & preventing loops
              >
                <div className="video-container text-center">
                  {/* Video with controlled width & height */}
                  <div>
                    <video className='video-main' controls loop>
                      <source
                        src="https://legal251resources.s3.ap-south-1.amazonaws.com/resources/garudmpvideo.MP4"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>

                    {/* Button Below Video */}
                    <div className="d-flex justify-content-center align-items-center mt-4">
                      <Link
                        to="/user-chatbot"
                        style={{ textDecoration: "none" }}
                      >
                        <button className="try-ai-btn" onClick={() => setShow(false)}>
                          <img src="img/try-ai.svg" alt="try-ai" />
                          Click here to try AI
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </>
        )

      }

    </div>
  )
}
